import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { User } from './user.model';
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class UserService {
  readonly rootUrl = AppSettings.webApiURL;
  constructor(private http: HttpClient) { }

  registerUser(user: User) {
    const body: User = {
      UserName: user.UserName,
      Password: user.Password,
      Email: user.Email,
      FirstName: user.FirstName,
      LastName: user.LastName
    }
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + '/api/User/Register', body, { headers: reqHeader });
  }

  userAuthentication(userName, password) {
    var data = "username=" + userName + "&password=" + password + "&grant_type=password";
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + '/token', data, { headers: reqHeader });
  }

  getUserOTP(userName) {
    const body: User = {
      UserName: userName,
      Password: "",
      Email: "",
      FirstName: "",
      LastName: ""
    }
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + '/api/User/Otp', body, { headers: reqHeader });
  }

  getUserClaims() {
    return this.http.get(this.rootUrl + '/api/GetUserClaims');
  }

  getPageData() {
    return this.http.get(this.rootUrl + '/api/Page/GetPage1');
  }

  getReport() {
    return this.http.get(this.rootUrl + '/api/Test/Get');
  }

  getUserCustomers() {
    return this.http.get(this.rootUrl + '/api/GetUserCustomers');
  }

  setCurrentCustomer(customerId) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(this.rootUrl + '/api/User/SetUserCurrentCustomer', customerId, { headers });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/shared/user.service.ts